import { merge } from 'lodash-es'
import { withInstall } from '../_util'

import Tree from './Tree.vue'
import { TransformOptions, TreeData } from './Tree'
import * as TreeUtils from './utils'

export const OTree = withInstall<
  typeof Tree & {
    toTreeNodes: (array: TreeData, options?: TransformOptions) => TreeData
    toArray: (treeNodes: TreeData, options?: TransformOptions) => TreeData
  },
  {}
>(merge(Tree, TreeUtils), {})
export default OTree

export * from './Tree'
